module.exports = __webpack_public_path__ + "img/New Year 4.b193bbff.jpeg";